import { z } from 'zod';

export const createOrganizationSchema = z.object({
  org_name: z.string().min(1, 'Organization name is required'),
  org_phone: z.string().min(1, 'Organization phone is required'),
  email: z.string().min(1, 'Organization email is required').email('Invalid email format'),
  sync_link: z.string().optional(),
  notification_email: z
    .string()
    .min(1, 'Notification email is required')
    .email('Invalid email format'),
  client_address: z.object({
    street: z.string().min(1, 'Street address is required'),
    city: z.string().min(1, 'City is required'),
    state: z
      .string()
      .min(1, 'State is required')
      .length(2, 'State must be exactly 2 characters')
      .transform((val) => val.trim().toUpperCase()),
    zip: z.string().min(1, 'Zip code is required'),
  }),
  timezone: z.string().min(1, 'Timezone is required'),
  activeClient: z.boolean().default(true),
  active_subscription: z.boolean().default(false),
  accepted_terms: z.boolean().default(false),
  is_onboarding_complete: z.boolean().default(false),
  primary_contact: z.object({
    name: z.string().min(1, 'Primary contact name is required'),
    title: z.string().min(1, 'Primary contact title is required'),
    email: z.string().min(1, 'Primary contact email is required').email('Invalid email format'),
    phone: z.string().min(10, 'Valid phone number is required'),
  }),
});

export type CreateOrganizationFormData = z.infer<typeof createOrganizationSchema>;
